module.exports = __webpack_public_path__ + "static/media/logo-white.73fb38f3.png";